import React, { useCallback, forwardRef } from 'react'
import Button from 'components/Common/Button'
import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import Slide from '@mui/material/Slide'
// import CloseIcon from '@mui/icons-material/Close'

import { SECONDARY_BUTTON } from 'themes/theme'
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DialogContent = styled(Box)(({ theme }) => ({
  width: {
    xs: '100%',
    sm: '300px',
    md: '400px',
    lg: '500px',
    xl: '500px',
  },
  display: 'flex',
  alignItems: 'center',
  gap: '50px',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '45px',
}))

const DialogActionBar = styled(Box)(() => ({
  width: '100%',
  gap: '2rem',
  marginTop: '2rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}))

const ConfirmDialog = props => {
  const { show, setShow, onSuccess, title, content, SuccessMessage, content2 } = props
  const onCloseModal = useCallback(() => {
    if (setShow) {
      setShow(false)
    }
  }, [setShow])

  const handleConfirm = () => {
    if (onSuccess) {
      onSuccess()
    }
    onCloseModal()
  }

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCloseModal}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{style: { borderRadius: '20px' }}}
    >
      <DialogContent>
        <Typography component="div" variant="h6" sx={{ textAlign: 'center', maxWidth: 'calc(100% - 60px)' }}>
          {title}
        </Typography>
        <Typography component="div" variant="body1" sx={{ textAlign: 'center', marginTop: '-20px' }}>
          {content}
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center', marginTop: '-40px' }}>
          {content2}
        </Typography>
        <DialogActionBar sx={{marginTop: '-20px'}}>
          <Button sx={{width:'230px'}} type={SECONDARY_BUTTON} onClick={onCloseModal}>
            Cancel
          </Button>
          <Button sx={{width:'230px'}} negative onClick={handleConfirm}>
            {SuccessMessage}
          </Button>
        </DialogActionBar>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDialog
